export default "__VITE_ASSET__93Td9EnY__"